import apiClient from "../../../utils/interceptor";
import { API_URLS } from "../../../constants";

// Get company configuration
export const getCompanyConfiguration = async (companyId) => {
    try {
        const response = await apiClient.get(
            `${API_URLS.COMPANY_CONFIG.GET_COMPANY_CONFIGURATION}/${companyId}`
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching company configuration:", error);
        throw error;
    }
};

// Create company configuration
export const createCompanyConfiguration = async (configParams) => {
    try {
        const response = await apiClient.post(
            API_URLS.COMPANY_CONFIG.CREATE_COMPANY_CONFIGURATION,
            configParams
        );
        return response.data;
    } catch (error) {
        console.error("Error creating company configuration:", error);
        throw error;
    }
};

// Update company configuration
export const updateCompanyConfiguration = async (configData) => {
    try {
        const response = await apiClient.patch(
            API_URLS.COMPANY_CONFIG.UPDATE_COMPANY_CONFIGURATION,
            configData
        );
        return response.data;
    } catch (error) {
        console.error("Error updating company configuration:", error);
        throw error;
    }
};

// Delete company configuration
export const deleteCompanyConfiguration = async (companyId) => {
    try {
        const response = await apiClient.delete(
            API_URLS.COMPANY_CONFIG.DELETE_COMPANY_CONFIGURATION,
            { data: { company_id: companyId } }
        );
        return response.data;
    } catch (error) {
        console.error("Error deleting company configuration:", error);
        throw error;
    }
};